require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./careers-user-experience-udesigner-uk.json") })
        }
      }, "path---careers-user-experience-udesigner-uk");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---careers-user-experience-udesigner-uk!./.cache/json/careers-user-experience-udesigner-uk.json
// module id = 882
// module chunks = 231608221292675